import * as React from "react";
import { Edit, SimpleForm, AutocompleteInput, TextInput, PasswordInput, ArrayInput, SimpleFormIterator, ReferenceArrayInput, SelectArrayInput } from 'react-admin';

export const RuleUpdate = props => (
  <Edit title="Edit External" undoable={false} {...props}>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="title" required />
      <TextInput source="field_label" required />
      <ArrayInput source="entries_value" label="Values">
        <SimpleFormIterator>
          <TextInput label="Header value" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);
